export enum Role {
  System = "SYSTEM",
  Admin = "ADMIN",
  Client = "CLIENT"
}
